import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../../fx/FxLog';
import * as FxFetch from '../../../fx/FxFetch';
import { useTranslation } from '../../../hx/useTranslation';
import CxDialog from '../../../cx/CxDialog';
import CxInput from '../../../cx/CxInput';
import CxCombo from '../../../cx/CxCombo';
import CxSnackbar from '../../../cx/CxSnackbar';
import CxSearcher from '../../../cx/CxSearcher';
import CxDlgAlert from '../../../cx/CxDlgAlert'; // Importación necesaria
import MxTypeOTF from './MxTypeOTF';
import '../../../../styles/main.css';
import { getStoreValue, } from "../../../gx/GxStore";


const MxAnimalOTF = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const [disabled, ] = React.useState(false);
  const [inClient, setInClient] = React.useState('');

  const rf_txAnimal = React.useRef(null);
  const rf_txNumberAnimals = React.useRef(null);
  const rf_txTypeAnimalSpecies = React.useRef(null);
  const rf_txTypeAnimalBreed = React.useRef(null);
  const rf_boGender = React.useRef(null);
  const rf_txChip = React.useRef(null);
  const rf_txNotes = React.useRef(null);

  const r_dlg_new_species = React.useRef(null);
  const r_dlg_new_breed = React.useRef(null);
  const r_dlg_alert = React.useRef(null); // Referencia para la alerta

  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg, setInClient,
    };
  });

  const formLoad = async () => { }

  const formSave = async () => {
    // Validaciones
    if (rf_txAnimal.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txAnimal.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    // --- PROCESO DE GUARDADO ---
    setDlg(false); // Ocultamos ventana principal

    r_dlg_alert.current.setText(trans('msg.saving'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);

    let txAnimal = rf_txAnimal.current.getVal();
    let txNumberAnimals = rf_txNumberAnimals.current.getVal();
    let itAnimalSpecies = rf_txTypeAnimalSpecies.current.getKey();
    let itAnimalBreed = rf_txTypeAnimalBreed.current.getKey();
    let boGender = rf_boGender.current.getVal();
    let txChip = rf_txChip.current.getVal();
    let txNotes = rf_txNotes.current.getVal();

    let record = {};
    record['inClient'] = inClient;
    record['inEmployee'] = getStoreValue('StoreSession', 'inEmployee');
    record['txAnimal'] = txAnimal;
    record['txNumberAnimals'] = txNumberAnimals;
    record['itAnimalSpecies'] = itAnimalSpecies;
    record['itAnimalBreed'] = itAnimalBreed;
    record['boGender'] = boGender;
    record['txChip'] = txChip;
    record['txNotes'] = txNotes;

    Promise.all([FxFetch.doJsonX("animals/otf", record)]).then((result) => {
      r_dlg_alert.current.setOpen(false); // Cerramos espera

      if (result[0]) {
        if (result[0].theValue === null) {
          // Ya existe: reabrimos formulario
          setDlg(true);
          r_snack_exists.current.setVal(trans('msg.x_exists', 'field.patient'));
          r_snack_exists.current.setOpen(true);
        } else {
          // Éxito
          let inAnimal = result[0].theValue;
          if (props.onOk) props.onOk(inAnimal, txAnimal);
        }
      }
    }).catch((error) => {
      // Error técnico: reabrimos formulario
      r_dlg_alert.current.setOpen(false);
      setDlg(true);
      FxLog.errorx("MxAnimalOTF.formSave", error);
    });
  }

  const speciesChanged = async (row) => {
    if (row !== null) {
      let itAnimalSpecies = row.original.itAnimalSpecies;
      rf_txTypeAnimalBreed.current.setFilter(`t_animal_breed.itAnimalSpecies='${itAnimalSpecies}'`);
      rf_txTypeAnimalBreed.current.clear();
    }
  }

  const clearBreed = () => {
    rf_txTypeAnimalBreed.current.clear();
  }

  const canOpenDlgBreed = () => {
    return rf_txTypeAnimalSpecies.current.getKey() !== '';
  }

  return (
    <div>
      <CxDialog title={trans('field.create_x', 'field.patient')} open={dlg} onOk={formSave} onClose={() => setDlg(false)} >
        <CxInput xref={rf_txAnimal} label={trans('field.patient')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={50} required />
        <CxInput xref={rf_txNumberAnimals} label={trans('field.number_animals')} disabled={disabled} width='var(--ibs_control_width_md)' defaultValue={'1'} maxLength={10} />

        <CxSearcher xref={rf_txTypeAnimalSpecies} label={trans('field.species')}
          dbfield="t_animal_species.txTypeAnimalSpecies" dbfieldkey="n_animal.itAnimalSpecies"
          tooltip={trans('field.species')}
          onSelection={speciesChanged}
          onClear={clearBreed}
          onButtonAddOTF={() => {
            rf_txTypeAnimalSpecies.current.setDlg(false);
            r_dlg_new_species.current.setDlg(true);
          }}
          url="sett/animal_species"
          col_id="itAnimalSpecies"
          col_tx="txTypeAnimalSpecies"
          columns={[
            { id: "0", Header: "ID", accessor: "itAnimalSpecies", show: false },
            { id: "1", Header: trans('field.species'), accessor: row => rf_txTypeAnimalSpecies.current.getTable().highlightText(row["txTypeAnimalSpecies"]), width: '100%' },
          ]}
          width='var(--ibs_control_width_md)'
          disabled={disabled}
        />

        <CxSearcher xref={rf_txTypeAnimalBreed} label={trans('field.breed')}
          dbfield="t_animal_breed.txTypeAnimalBreed" dbfieldkey="n_animal.itAnimalBreed"
          tooltip={trans('field.breed')}
          canOpenDialog={canOpenDlgBreed}
          onButtonAddOTF={() => {
            rf_txTypeAnimalBreed.current.setDlg(false);
            r_dlg_new_breed.current.setDlg(true);
          }}
          url="sett/animal_breed"
          col_id="itAnimalBreed"
          col_tx="txTypeAnimalBreed"
          columns={[
            { id: "0", Header: "ID", accessor: "itAnimalBreed", show: false },
            { id: "1", Header: trans('field.breed'), accessor: row => rf_txTypeAnimalBreed.current.getTable().highlightText(row["txTypeAnimalBreed"]), width: '100%' },
          ]}
          width='var(--ibs_control_width_md)'
          disabled={disabled}
        />

        <CxCombo xref={rf_boGender}
          label={`${trans('field.gender')}`}
          dbfield='n_animal.boGender'
          list={[
            { id: '0', type: trans('field.animal_female') },
            { id: '1', type: trans('field.animal_male') },
            { id: '2', type: trans('field.na') },
          ]}
          width='var(--ibs_control_width_md)'
          disabled={disabled}
        />

        <CxInput xref={rf_txChip} label={trans('field.chip')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={23} />
        <CxInput xref={rf_txNotes} label={trans('field.notes')} disabled={disabled} width='var(--ibs_control_width_md)' minRows={2} />
      </CxDialog>

      <MxTypeOTF xref={r_dlg_new_species}
        url="animals/species/otf"
        name='field.species'
        onOk={(itXXX, txTypeXXX) => {
          rf_txTypeAnimalSpecies.current.setKey(itXXX);
          rf_txTypeAnimalSpecies.current.setVal(txTypeXXX);
          rf_txTypeAnimalBreed.current.setFilter(`t_animal_breed.itAnimalSpecies='${itXXX}'`);
          rf_txTypeAnimalBreed.current.clear();
        }}
      />
      <MxTypeOTF xref={r_dlg_new_breed}
        url="animals/breed/otf"
        name='field.breed'
        parent={rf_txTypeAnimalSpecies}
        onOk={(itXXX, txTypeXXX) => {
          rf_txTypeAnimalBreed.current.setKey(itXXX);
          rf_txTypeAnimalBreed.current.setVal(txTypeXXX);
        }}
      />

      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" />

    </div>
  );
}

export default MxAnimalOTF;